/* 🤖 this file was generated by svg-to-ts */
export const matIconChromeReaderMode: {
  name: 'chrome-reader-mode';
  data: string;
} = {
  name: 'chrome-reader-mode',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM3 19V6h8v13H3zm18 0h-8V6h8v13zm-7-9.5h6V11h-6zm0 2.5h6v1.5h-6zm0 2.5h6V16h-6z"/></svg>`
};
